import { Link } from "react-router-dom";
import LoginForm from "../components/auth/LoginForm";
import "./LoginPage.css";

export default function LoginPage() {
  return (
    <div className="login-page">
      <div className="login-page__card">
        <div className="login-page__header">
          <span className="login-page__eyebrow">Good to see you again ✨</span>
          <h1>Login and thrive</h1>
          <p>Missed us? Your creator tools are right where you left them.</p>
        </div>

        <LoginForm variant="page" />

        <p className="login-page__footer">
          Don’t have an account yet? <Link to="/signup">Start your free trial</Link>
        </p>
      </div>
    </div>
  );
}
